import '@babel/polyfill/noConflict'
import React from 'react'
import ReactDOM from 'react-dom'

import ProfileComponent from '../component/ProfileComponent'
import ErrorPageComponent from '../component/ErrorPageComponent'
import ProfileSettingsContext from '../context/ProfileSettingsContext'
import profileOfferSettings from "../store/ProfileOfferSettings"

export default class ProfileSettingsController {
    init(state, importexport_controller, jQuery, mount_root_id) {
        if (!state) {
            this._renderError(importexport_controller, mount_root_id)

            return
        }

        const context = this._createContext(state)
        this._updateImportexportControllerProfiles(importexport_controller, jQuery, context.profiles)

        if (window.location.hash === '#/market/') {
            let profile_id = ''

            if (importexport_controller.profiles.list.market) {
                const ids = Object
                    .keys(importexport_controller.profiles.list.market)
                    .sort((id_1, id_2) => importexport_controller.profiles.list.market[id_2].sort - importexport_controller.profiles.list.market[id_1].sort)

                if (ids.length > 0) {
                    profile_id = ids[0]
                }
            }

            window.location.hash = `#/market:${profile_id}/`
        }

        this._renderProfile(context, mount_root_id)

        if (context.with_profile) {
            this._renderCloneProfileButton(context.profile.id, jQuery, importexport_controller)
        }
    }

    /**
     * @param state
     * @return {ProfileSettingsContext}
     * @private
     */
    _createContext(state) {
        return new ProfileSettingsContext(state)
    }

    _renderProfile(context, mount_root_id) {
        const mount_root = document.getElementById(mount_root_id)
        if (!mount_root) {
            console.warn('нет элемента с id [' + mount_root_id + ']')

            return
        }

        ReactDOM.render(
            <ProfileComponent context={context}/>,
            mount_root
        )
    }

    _updateImportexportControllerProfiles(importexport_controller, $, profiles) {
        importexport_controller.profiles.set('market', profiles)

        if (window.shop_market_plugin_ajax_success_initialized) {
            return
        }

        window.shop_market_plugin_ajax_success_initialized = true

        $(document).ajaxSuccess(async function (event, jqXHR, ajaxOptions) {
            if (!ajaxOptions) {
                return
            }

            const link = document.createElement('a')
            link.href = ajaxOptions.url

            const query_parts = link.search.replace(/^\?/, '').split('&')

            let module = null
            let action = null

            query_parts.forEach(part => {
                const param = part.split('=')
                if (param.length !== 2) {
                    return
                }

                if (param[0] === 'module') {
                    module = param[1]
                }

                if (param[0] === 'action') {
                    action = param[1]
                }
            })

            if (module === 'importexport' && action === 'delete') {
                const response = await $.ajax({
                    url: '?plugin=market&module=profileSettings&action=deleteProfile',
                    method: 'POST',
                    dataType: 'json',
                    data: ajaxOptions.data
                })

                if (response && response.data && response.data.success) {
                    importexport_controller.profiles.set('market', response.data.profiles)
                }
            }
        })
    }

    _renderError(importexport_controller, mount_root_id) {
        const empty_profile = {
            id: '',
            name: 'error',
            plugin: 'market',
            description: '',
            sort: 0,
        }

        importexport_controller.profiles.set('market', [empty_profile])
        const profile_menu_id = importexport_controller.$profile && importexport_controller.$profile.length
            ? importexport_controller.$profile.prop('id')
            : null

        const mount_root = document.getElementById(mount_root_id)
        if (!mount_root) {
            console.warn('нет элемента с id [' + mount_root_id + ']')

            return
        }

        ReactDOM.render(
            <ErrorPageComponent profile_menu_id={profile_menu_id}/>,
            mount_root
        )
    }

    _renderCloneProfileButton(profile_id, $, importexport_controller) {
        $('.js-market-plugin__clone-block').remove()

        const $clone_block = $('<li class="no-tab float-right small js-market-plugin__clone-block"></li>')

        const $clone_button = $('<a><i class="fas fa-copy text-blue"></i>Создать копию</a>')
        const $loading = $('<i class="fas fa-spinner wa-animation-spin"></i>')

        $clone_button.on('click', async (event) => {
            event.preventDefault()
            event.stopPropagation()
            event.stopImmediatePropagation()

            $clone_button.hide()
            $loading.show()

            const response = await $.ajax({
                url: '?plugin=market&module=profileSettings&action=cloneProfile',
                method: 'POST',
                dataType: 'json',
                data: {
                    'profile_id': profile_id
                },
            })

            if (response && response.data && response.data.success) {
                const {new_profile_id, profiles} = response.data.state

                this._updateImportexportControllerProfiles(importexport_controller, $, profiles)

                window.location.hash = `#/market:${new_profile_id}/`
            } else {
                $clone_button.show()
                $loading.hide()
            }

            return false
        })

        $loading.hide()

        $clone_block.append($clone_button)
        $clone_block.append($loading)

        if (window.ui_version === '1.3') {
            $('#s-importexport-profile .delete-link-wrapper').after($clone_block);
        } else {
            $('#s-importexport-profile .delete-link-wrapper').before($clone_block);
        }

        $('#s-importexport-profile').show()
    }
}